/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulworkshopcompentencetwo5Inputs */

const de__field_participatedulworkshopcompentencetwo5 = /** @type {(inputs: _Field_Participatedulworkshopcompentencetwo5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Workshop Competence Two`)
};

/**

* @param {_Field_Participatedulworkshopcompentencetwo5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulworkshopcompentencetwo5 = /** @type {((inputs?: _Field_Participatedulworkshopcompentencetwo5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulworkshopcompentencetwo5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulworkshopcompentencetwo5(inputs)
});
export { _field_participatedulworkshopcompentencetwo5 as "_field_participatedULWorkshopCompentenceTwo" }